'use client'
import { ContactUsForm } from '@/app/components/ContactUsForm'
import dynamic from 'next/dynamic'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const ContactUsPage = () => {
	return (
		<GoogleReCaptchaProvider
			reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY as string}
		>
			<ContactUsForm />
		</GoogleReCaptchaProvider>
	)
}

export default dynamic(() => Promise.resolve(ContactUsPage), {
	ssr: false,
})
